import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useState } from 'react';
import CorpListDetailInfoPopup from './corp-list-detail-info-popup';
import CorpListStore from './corp-list-store';

// 법인 사용자 등록 / 상세정보
const CorpListDetailInfoPopupContainer = () => {
  // console.log('CorpListDetailInfoPopupContainer Load');

  const { detailInfo, detailInfoMode, visibleDetailInfoPopup } = CorpListStore;
  const [copyDetailInfo, setCopyDetailInfo] = useState();

  const itemsUseCheck = [
    { key: 0, value: '회사내규' },
    { key: 1, value: '금액' },
    { key: 2, value: '횟수' },
  ];

  useEffect(() => {
    //console.log('CorpListDetailInfoPopupContainer > useEffect()');

    if (detailInfo) {
      if (detailInfoMode === 'I') {
        setCopyDetailInfo({
          ...detailInfo,
          LineNumberSeachState: 1, // 1 : 등록화면, 2 : 상세정보화면/조회기존고객등록, 3 : 조회신규고객등록
          UseCheck: 0,
          UseCheckValue: 0,
        });
      } else {
        setCopyDetailInfo({ ...detailInfo, LineNumberSeachState: 2 });
        sessionStorage.setItem('LineNumber',detailInfo.LineNumber);
        //console.log('LineNumber::',sessionStorage.getItem('LineNumber'));
      }
    }
  }, [detailInfo, detailInfoMode]);

  const onFieldDataChanged = useCallback((e) => {
    const { dataField, value } = e;

    // console.log(
    //   `onFieldDataChanged - dataField : ${dataField}, value : ${value}`
    // );

    setCopyDetailInfo((copyDetailInfo) => ({
      ...copyDetailInfo,
      [dataField]: value,
    }));
  }, []);

  const onValueChanged = useCallback((name, e) => {
    const { value } = e;

    //console.log(`onValueChanged - name : ${name}, value : ${value}`);

    if (name === 'UseCheck' && value === '0') {
      setCopyDetailInfo((copyDetailInfo) => ({
        ...copyDetailInfo,
        UseCheckValue: 0,
      }));
    }

    setCopyDetailInfo((copyDetailInfo) => ({
      ...copyDetailInfo,
      [name]: name === 'UseCheck' ? parseInt(value) : value,
    }));
  }, []);

  // 전화번호 조회
  const onClickLineNumberSearch = useCallback(async () => {
    if (copyDetailInfo.LineNumberSeachState === 1) {
      if (!copyDetailInfo.LineNumber) {
        alert('전화번호를 입력해주세요.');
        return;
      }

      const userInfo = await CorpListStore.getUserInfo(
        copyDetailInfo.LineNumber
      );

      if (userInfo) {
        if (userInfo.Type === '2') {
          alert('이미 등록된 법인고객입니다.');
          return;
        }

        setCopyDetailInfo({ ...userInfo, LineNumberSeachState: 2 });
      } else {
        if (
          window.confirm(
            `(${copyDetailInfo.LineNumber})번으로 등록된 데이터가 없습니다.\n신규고객으로 등록하시겠습니까?`
          )
        ) {
          setCopyDetailInfo({
            ...copyDetailInfo,
            LineNumberSeachState: 3,
            TypeName: '법인',
          });
        }
      }
    } else {
      setCopyDetailInfo({
        LineNumber: copyDetailInfo.LineNumber,
        LineNumberSeachState: 1,
        UseCheck: 0,
        UseCheckValue: 0,
      });
    }
  }, [copyDetailInfo]);

  // 결제카드 카드등록 / 카드해지
  const onClickPaymentState = useCallback(async () => {
    if (copyDetailInfo.PaymentState === 0) {
      // 카드등록
      CorpListStore.setVisibleCardInfoPopup(true);
    } else {
      // 카드해지
      if (window.confirm('카드등록을 해지하시겠습니까?')) {
        const result = await CorpListStore.deleteCardInfo(
          copyDetailInfo.CustomerCode,
          1
        );

        if (result.error) {
          alert(result.message);
        } else {
          CorpListStore.setVisibleDetailInfoPopup(false);
          CorpListStore.getUserList();
        }
      }
    }
  }, [copyDetailInfo]);

  // 이용내역
  const onClickUseInfo = useCallback(async () => {
    const result = await CorpListStore.getUseInfoList(
      copyDetailInfo.CustomerCode,
      3
    );

    if (result.error) {
      alert(result.message);
    }
  }, [copyDetailInfo]);

  // 변경내역
  const onClickUpdateInfo = useCallback(async () => {
    const result = await CorpListStore.getUpdateInfoList(
      copyDetailInfo.CustomerCode
    );

    if (result.error) {
      alert(result.message);
    }
  }, [copyDetailInfo]);

  // 법인 사용자 등록
  const onClickInsert = useCallback(async () => {
    if (copyDetailInfo.LineNumberSeachState === 1) {
      alert('전화번호 조회 후 등록이 가능합니다.');
      return;
    }

    if (!copyDetailInfo.Name || copyDetailInfo.Name === '') {
      alert('이름은 필수 입력항목입니다.');
      return;
    }

    if (!copyDetailInfo.Part || copyDetailInfo.Part === '') {
      alert('부서는 필수 입력항목입니다.');
      return;
    }

    if (!copyDetailInfo.Duty || copyDetailInfo.Duty === '') {
      alert('직책은 필수 입력항목입니다.');
      return;
    }

    let result;

    if (copyDetailInfo.LineNumberSeachState === 2) {
      // 기존고객등록
      result = await CorpListStore.updateUserInfo(copyDetailInfo);
    } else {
      // 신규고객등록
      result = await CorpListStore.insertUserInfo(copyDetailInfo);
    }

    if (result.error) {
      alert(result.message);
    } else {
      CorpListStore.setVisibleDetailInfoPopup(false);
      CorpListStore.getUserList();
    }
  }, [copyDetailInfo]);

  // 법인사용자 수정
  const onClickUpdate = useCallback(async () => {
    if (!copyDetailInfo.Name || copyDetailInfo.Name === '') {
      alert('이름은 필수 입력항목입니다.');
      return;
    }

    if (!copyDetailInfo.Part || copyDetailInfo.Part === '') {
      alert('부서는 필수 입력항목입니다.');
      return;
    }

    if (!copyDetailInfo.Duty || copyDetailInfo.Duty === '') {
      alert('직책은 필수 입력항목입니다.');
      return;
    }

    const result = await CorpListStore.updateUserInfo(copyDetailInfo);

    if (result.error) {
      alert(result.message);
    } else {
      CorpListStore.setVisibleDetailInfoPopup(false);
      CorpListStore.getUserList();
    }
  }, [copyDetailInfo]);

  // 법인 사용자 해지
  const onClickDelete = useCallback(async () => {
    if (
      window.confirm(
        '법인등록 해지처리 하시겠습니까?\n(※등록해지 후 등록→전화번호 조회로 재등록 가능합니다.)'
      )
    ) {
      const result = await CorpListStore.deleteUserInfo(
        copyDetailInfo.CustomerCode
      );

      if (result.error) {
        alert(result.message);
      } else {
        CorpListStore.setVisibleDetailInfoPopup(false);
        CorpListStore.getUserList();
      }
    }
  }, [copyDetailInfo]);

  if (!copyDetailInfo) {
    return;
  }

  return (
    <CorpListDetailInfoPopup
      onHiding={() => CorpListStore.setVisibleDetailInfoPopup(false)}
      onFieldDataChanged={onFieldDataChanged}
      onValueChanged={onValueChanged}
      onClickLineNumberSearch={onClickLineNumberSearch}
      onClickInsert={onClickInsert}
      onClickUpdate={onClickUpdate}
      onClickDelete={onClickDelete}
      onClickUseInfo={onClickUseInfo}
      onClickUpdateInfo={onClickUpdateInfo}
      onClickPaymentState={onClickPaymentState}
      detailInfo={copyDetailInfo}
      detailInfoMode={detailInfoMode}
      visibleDetailInfoPopup={visibleDetailInfoPopup}
      itemsUseCheck={itemsUseCheck}
    />
  );
};

export default React.memo(observer(CorpListDetailInfoPopupContainer));
